import DraggableModal from 'components/organisms/draggableModal';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseForm from 'components/atoms/base-form';
import { AppendixCForm } from 'components/organisms/device-troubleshoot-templates/templates/deviceTroubleshootForm';
import FormItemWrapper from 'components/molecules/rpm-alert-assessment/formItemWrapper';

import s from '../../styles.module.scss';
import { useAppendixC } from '../../hooks/use-appendix-c-modal';
import { useStoreModalValue } from '../../hooks/use-store-modal-value';
import { appendixCValidationSchema } from '../../validation-schema';

import type { IAppendixCModalProps } from '../../types';
import type { FC } from 'react';

const AppendixCModal: FC<IAppendixCModalProps> = ({
  isOpen,
  patientGuid,
  handleSubmit,
  closeModal,
  setWhichPerson,
  setOtherPerson,
}) => {
  const { t } = useTranslation();
  const { initialValues, onSaveForm } = useAppendixC({
    closeModal,
    handleSubmit,
  });

  const type = 'min';

  type TInitialValues = typeof initialValues;
  const { parsedData, setModalValuesToStorage } =
    useStoreModalValue<TInitialValues>({
      modalName: `appendixC_${patientGuid}`,
    });

  const formik = useFormik({
    initialValues: parsedData ?? initialValues,
    onSubmit: (data) => {
      setModalValuesToStorage(data);
      onSaveForm(data);
    },
    validateOnChange: false,
    validationSchema: appendixCValidationSchema(),
  });

  const onSave = () => {
    setWhichPerson(formik.getFieldMeta('whichPerson').value);
    if (formik.getFieldMeta('whichPerson').value === 'Other') {
      setOtherPerson(formik.getFieldMeta('otherPerson').value);
    }
    formik.submitForm();
  };

  const expandableExtraFields = ['whichPerson', 'reasonForCall'];

  return (
    <>
      <DraggableModal
        isOpen={isOpen}
        toggle={closeModal}
        title={t('labels.RPMSpecialistTemplate')}
        onSave={onSave}
        dataCy="RPMSpecialistTemplate"
      >
        <BaseForm formik={formik}>
          <div className={s.wrapper}>
            {AppendixCForm.map((formItem, index) => {
              const isShowExtraFields = expandableExtraFields.includes(
                formItem.name,
              )
                ? formik
                    .getFieldMeta(formItem.name)
                    ?.value?.includes('Other') ||
                  formik.getFieldMeta(formItem.name)?.value === 'Other'
                : undefined;

              return (
                <FormItemWrapper
                  formik={formik}
                  index={index}
                  formItem={formItem}
                  type={type}
                  requiredSymptomFields={[]}
                  isShowExtraFields={isShowExtraFields}
                  patientGuid={patientGuid}
                />
              );
            })}
          </div>
        </BaseForm>
      </DraggableModal>
    </>
  );
};

export default AppendixCModal;
